export default __webpack_public_path__ + "static/media/buddy5.bddc0185.jpeg";